import { IsThreeJsType } from '@3d-scene/common/util/is-threejs-type';
import { MeshBasicMaterial } from 'three';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { BaseContainer3D } from '@3d-scene/model3d/base-container-3d';
import { MeshUtils } from '@3d-scene/common/util/mesh-utils';
import { ProjectModel } from '@project/model/project.model';

export class DrillingHoleArticlePostParseProcessor {

  private static DRILLING_HOLE_MATERIAL = new MeshBasicMaterial({color: 0xffffff});

  public static process(articleContainer: ArticleContainer, articleVO: ArticleVO, renderOrder: number = 0): void {
    if (articleContainer.articleObject3DDataShared) {
      throw new Error('Modifying a shared article geometry is not allowed!');
    }
    const articleUsage: ArticleUsageVO = articleContainer.articleUsage;
    let articleLength: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(articleUsage,
      ArticleUsageInfoPropertyDef.ARTICLE_LENGTH);
    let articleOffset: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(articleUsage,
      ArticleUsageInfoPropertyDef.ARTICLE_OFFSET);

    if (!NumberUtils.isNumber(articleLength) || !NumberUtils.isNumber(articleOffset)) {
      const projectModel: ProjectModel = articleContainer.projectModel;
      articleLength = projectModel.lastDrillingHoleLength;
      articleOffset = projectModel.lastDrillingHoleOffset;
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(articleUsage, ArticleUsageInfoPropertyDef.ARTICLE_LENGTH, articleLength);
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(articleUsage, ArticleUsageInfoPropertyDef.ARTICLE_OFFSET, articleOffset);
    }

    const connectionNames = [];
    const article: ArticleVO = articleContainer.article;
    for (const con of article.metaElements) {
      connectionNames.push(con.name);
    }

    if (articleContainer instanceof BaseContainer3D) {
      articleContainer.extrude(articleLength, 'y');
    }

    // remove shading for borehole using emissive Light color and set the rendering order to make it visible threw empty/blocking zones
    for (const child of articleContainer.model.children) {
      if (IsThreeJsType.mesh(child) && !MeshUtils.isConnection(child.name)) {
        if (IsThreeJsType.meshPhongMaterial(child.material)) {
          child.material = DrillingHoleArticlePostParseProcessor.DRILLING_HOLE_MATERIAL;
          child.renderOrder = renderOrder;
        }
      }
    }
  }
}
